import { styled, Typography, Button, Icon } from '@nextiva/next-ui-components';

const background = require('./PurchaseLicensesBannerBackground.png');

export const StyledBannerContainer = styled('div')`
  display: flex;
  justify-content: space-between;
  background: ${({ theme }) => theme.palette.primary.light};
  padding: 16px 32px;
  margin-top: 15px;
  background-image: url(${background});
  border-radius: 16px;
`;
export const StyledBannerText = styled(Typography)`
  color: ${({ theme }) => theme.palette.secondary.contrastText};
`;
export const StyledPurchaseButton = styled(Button)`
  margin-left: 16px;
  min-width: 181px;
  max-width: 181px;

  &&.MuiButton-root {
    border-radius: 40px;
    height: 40px;
    align-self: center;
  }
`;
export const StyledPurchaseButtonIcon = styled(Icon)`
  margin-left: -14px;
`;
export const StyledPurchaseButtonText = styled(Typography)`
  margin: 0px -14px 0px 12px;
`;
